import { useMutation } from '@connectrpc/connect-query'
import { exportCustomerContracts } from '@ebalance/proto/bffuser/v1/customer_contract_csv_service-CustomerContractCsvService_connectquery'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 顧客契約 CSV エクスポート用の全件取得フック (uploads/common.md §6 AC-DUC-028/029)。
 *
 * `useExportSupply48Data` と同じ理由で `useMutation` を使う (= ダウンロードを開いた時の 1 回限りの
 * 命令的取得であり、 cache には載せない)。顧客管理の契約推移タブの「CSVエクスポート」も同じ hook を使う。
 */
export function useExportCustomerContracts(): InvalidatingMutationResultFor<
  typeof exportCustomerContracts
> {
  return useMutation(exportCustomerContracts)
}
